
const Layout = () => import("@/layout/index.vue")

export default {
    path: "/debug",
    redirect: "/debug/formula",
    component: Layout,
    meta: {
        icon: "ep:monitor",
        title: "调试工具",
        rank: 1000
    },
    children: [
        {
            path: "/debug/formula",
            name: "FormulaDebug",
            component: () => import("@/views/debug/formula-debug.vue"),
            meta: {
                title: "公式调试"
            }
        }
    ]
}
